import InitialOrderConsumptionData from '../../model/initial-order-consumption-data';
import { formatNumber } from '../../helpers/utils';

type AsyncConsumptionDataKey = keyof InitialOrderConsumptionData;

const selectors = {
  container: '.js-asyncConsumptionData',
  consumptionDataField: '.js-asyncField',
};

export default class AsyncConsumptionData {

  constructor(private readonly products: JQuery = $(selectors.container)) {
    if (this.products.length) {
      this.loadAsyncConsumptionData();
    }
  }

  static init(container: JQuery): AsyncConsumptionData {
    return new AsyncConsumptionData(container.find(selectors.container));
  }

  static initAll(): AsyncConsumptionData {
    return new AsyncConsumptionData();
  }

  private loadAsyncConsumptionData(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.fetchAsyncConsumptionData().done((data: InitialOrderConsumptionData[]) => {
      data.forEach((consumptionData): void => {
        const row = this.products.filter(`[data-code="${consumptionData.productCode}"]`);
        AsyncConsumptionData.populateFields(row, consumptionData);
      });
    }).fail((error) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (error.responseJSON?.length) {
        window.NotificationHelper.clearNotifications();
        window.NotificationHelper.showError(error.responseJSON);
      }
    });
  }

  private fetchAsyncConsumptionData(): JQuery.jqXHR {
    return $.ajax({
      url: `${window.ACC.config.encodedContextPath}/product/ioConsumptionProposals`,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(this.parseProductCodes()),
    });
  }

  private parseProductCodes(): string[] {
    const codes: string[] = [];
    this.products.each((index, element): void => {
      const productCode = $(element).data('code') as string;
      codes.push(productCode);
    });
    return codes;
  }

  private static populateFields(row: JQuery, data: InitialOrderConsumptionData): void {
    row.find(selectors.consumptionDataField).each((index, fieldEl) => {
      const field = $(fieldEl);
      const key = String(field.data('async-key') ?? '') as AsyncConsumptionDataKey;

      const fieldValue: unknown = data[key];
      if (fieldValue === null || fieldValue === undefined || fieldValue === 'undefined') {
        return;
      }
      field.text(formatNumber(fieldValue as number));
    });
  }
}
